import { Color } from 'three';

export const highlightColor = new Color('rgba(19,207,232,0.55)');
export const opponentPathColor = new Color('rgba(211,82,82,0.87)');
export const playerPathColor = new Color('rgba(57,143,227,0.87)');
